(ns guidebook.views.key-considerations
  (:require
   [guidebook.common :refer [format-date light-s]]
   [util.core :refer [valid-date?]]
   [very.re-frame.core :as rf :refer [>evt]]
   [cljss.core :as cljss]
   [css.core :refer [get-theme defstyled]]))

(defstyled key-considerations-s :div
  {:min-height "100vh"
   :padding "82px 100px"
   :position "relative"
   ::cljss/media {[:print]
                  {:padding "50px 100px 82px"}}})

(defstyled kc-header-s :div
  {:background "white"
   ::cljss/media {[:print]
                  {:background "black"
                   :margin-left "-100px"
                   :padding "100px"
                   :display "inline-block"}}})

(defstyled kc-title-s :h1
  {:color "black"
   :font-size "94px"
   :font-weight 300
   :text-transform "uppercase"
   :margin (with-meta #(or % "0 0 2rem") :margin)
   :max-width "970px"
   :line-height "110px"
   ::cljss/media {[:print]
                  {:font-size "68px"
                   :color "white"
                   :line-height "80px"
                   :-webkit-margin-before 0
                   :-webkit-margin-after 0
                   :margin (with-meta #(or % "0 0 2rem") :margin)}}})

(defstyled kc-description-s :div
  {:font-size "25px"
   :font-weight "300"
   :line-height "36px"
   ::cljss/media {[:print]
                  {:color "white"
                   :font-size "20px"
                   :line-height "32px"}}})

(defstyled considerations-list-s :ol
  {:display "grid"
   :margin-top "60px"
   :grid-template-columns "1fr 1fr 1fr"
   :grid-template-rows "1fr 1fr"
   :grid-column-gap "90px"
   :grid-row-gap "60px"
   :list-style "decimal"
   :margin-left "30px"
   :font-size "25px"
   :line-height "36px"
   ::cljss/media {[:print]
                  {:font-size "20px"
                   :line-height "32px"
                   :display "block"}}})

(defstyled consideration-s :li
  {:font-weight "bold"
   :padding-left "30px"
   :width "490px"
   :margin-bottom "40px"})

(defstyled updated-s :div
  {:color "white"
   :background-color (get-theme :primary)
   :position "absolute"
   :right "0"
   :bottom "20vh"
   :font-size "25px"
   :font-weight "300"
   :line-height "25px"
   :height "70px"
   :display "flex"
   :align-items "center"
   :justify-content "center"
   :padding "0 45px"
   ::cljss/media {[:print]
                  {:top "100px"
                   :bottom "auto"
                   :width "420px"
                   :font-size "20px"
                   :line-height "24px"}}})

(defn main []
  (let [kc (rf/subscribe [:guidebook/key-consideration])]
    (fn []
      [key-considerations-s
       [kc-header-s
        [kc-title-s {:margin "0"} "Key"]
        [kc-title-s "Considerations"]
        [kc-description-s "Achieving your goals is easier when you have clear priorities."]
        [kc-description-s "Your priorities should be a balance of concerns across your lifetime and beyond."]]
       [considerations-list-s
        (for [c (:considerations @kc)]
          ^{:key (random-uuid)}
          [consideration-s [light-s (:text c)]])]
       (when (valid-date? (:last-updated-at @kc))
         [updated-s (str "Last updated on " (format-date (:last-updated-at @kc)))])])))
